import type { FuseFlatNavItemType, FuseNavItemType } from "@fuse/core/FuseNavigation/types/FuseNavItemType";

class FuseNavigationHelper {
	static flattenNavigation(navigation: FuseNavItemType[], parentOrder = ""): FuseFlatNavItemType[] {
		if (!navigation) return [];

		return navigation.flatMap((item, index) => {
			const order = parentOrder ? `${parentOrder}.${index + 1}` : `${index + 1}`;
			let flattened: FuseFlatNavItemType[] = [
				{
					...item,
					order,
					children: item.children?.map((child) => child.id),
				},
			];

			if (item.children) flattened = flattened.concat(this.flattenNavigation(item.children, order));

			return flattened;
		});
	}

	static unflattenNavigation(navigation: FuseFlatNavItemType[]): FuseNavItemType[] {
		const itemMap: Record<string, FuseNavItemType> = {};
		navigation.forEach((item) => {
			itemMap[item.id] = { ...item, children: [] };
		});

		const rootItems: FuseNavItemType[] = [];

		navigation.forEach((item) => {
			if (item.order.includes(".")) {
				const parentOrder = item.order.substring(0, item.order.lastIndexOf("."));
				const parent = navigation.find((navItem) => navItem.order === parentOrder);

				if (parent) itemMap[parent.id].children.push(itemMap[item.id]);
			} else rootItems.push(itemMap[item.id]);
		});

		return rootItems.map((item) => {
			const { ...rest } = item;
			return rest;
		});
	}
}

export default FuseNavigationHelper;
